export default __webpack_public_path__ + "static/media/new-article-top.2a88d428.svg";